export const LEGACY_MEDICAL_INTAKE_DRAFT_PREFIX = 'sena_medical_intake_draft';
export const LEGACY_LACTATION_INTAKE_DRAFT_PREFIX = 'sena_lactation_intake_draft';

function isLegacyIntakeDraftKey(key) {
  if (!key) return false;
  return key === LEGACY_MEDICAL_INTAKE_DRAFT_PREFIX
    || key.startsWith(`${LEGACY_MEDICAL_INTAKE_DRAFT_PREFIX}:`)
    || key.startsWith(`${LEGACY_LACTATION_INTAKE_DRAFT_PREFIX}:`);
}

/** Removes legacy client intake draft keys that may contain PHI. Safe to call repeatedly. */
export function removeLegacyIntakeDraftLocalStorage() {
  if (typeof localStorage === 'undefined') return [];
  const removed = [];
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (!isLegacyIntakeDraftKey(key)) continue;
    try {
      localStorage.removeItem(key);
      removed.push(key);
    } catch {
      // Ignore quota or privacy mode errors during cleanup.
    }
  }
  return removed;
}
